/**
 * KTX2テクスチャをデコードするためのBasisトランスコーダー（.js / .wasm）の配信パス。
 *
 * 以前は jsdelivr の CDN から取得していたが、three のバージョンによっては
 * バージョン付きURLが301リダイレクトを返し、CORSプリフライトに失敗して
 * basis_transcoder.wasm を読み込めなくなる問題があった。
 * そのため `public/basis/` に同梱したファイルを同一オリジンから配信する。
 *
 * トランスコーダーは `npm install` 時の three のバージョンと一致させる必要があるため、
 * three を更新したら以下を再実行してファイルを更新すること:
 *   cp node_modules/three/examples/jsm/libs/basis/basis_transcoder.{js,wasm} public/basis/
 */
export const KTX2_TRANSCODER_PATH = '/basis/'
